import React, { useState } from "react";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");         
  const [message, setMessage] = useState("");     
  const [messageType, setMessageType] = useState("success"); 
  const [loading, setLoading] = useState(false);  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // POST request to your backend password reset endpoint
      await axios.post(
        `${process.env.REACT_APP_API_URL}users/custom-password-reset/`,
        { email },
      );

      // Show success message (generic to avoid leaking emails)
      setMessage(
        "If an account with this email exists, a password reset link has been sent. Please check your inbox."
      );
      setMessageType("success");
    } catch (error) {
      console.error("Password reset error:", error);

      // Show error message (fallback)
      setMessage(
        "Something went wrong while sending the reset link. Please try again later."
      );
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-4">Forgot Password</h2>

        {message && (
          <div
            className={`text-center mb-4 text-sm p-3 rounded ${
              messageType === "success"
                ? "text-green-700 bg-green-100"
                : "text-red-700 bg-red-100"
            }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Enter your email address:
          </label>
          <input
            type="email"
            required
            className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="stakeholder@example.com"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded transition"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
